import React from 'react';

export interface IconProps {
    size?: number;
    color?: string;
}

const wrap = (children: React.ReactNode, size = 20): React.ReactElement => (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{ verticalAlign: 'middle' }}>{children}</svg>
);

// 사다리
export const LadderIcon: React.FC<IconProps> = ({ size = 20, color = '#fff' }) => wrap(
    <g stroke={color} strokeWidth={2} fill="none" strokeLinecap="round">
        <line x1="6" y1="3" x2="6" y2="21" />
        <line x1="18" y1="3" x2="18" y2="21" />
        <line x1="6" y1="7" x2="18" y2="7" />
        <line x1="6" y1="12" x2="18" y2="12" />
        <line x1="6" y1="17" x2="18" y2="17" />
    </g>, size);

// 직접 입력
export const EditIcon: React.FC<IconProps> = ({ size = 20, color = '#667eea' }) => wrap(
    <g fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 013 3L7 19l-4 1 1-4z" />
    </g>, size);

// 총대 (과녁)
export const TargetIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => wrap(
    // 색을 세 개 쓰면 고른 칩(검은 면) 위에서 따로 놉니다. 선 하나로 그립니다.
    <g fill="none" stroke={color} strokeWidth={2}>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1.5" fill={color} stroke="none" />
    </g>, size);

// 일반 (사람)
export const PersonIcon: React.FC<IconProps> = ({ size = 20, color = '#BDBDBD' }) => wrap(
    <g fill={color}>
        <circle cx="12" cy="7" r="3.5" />
        <path d="M5 20c0-4 3-7 7-7s7 3 7 7z" />
    </g>, size);

// 순서
export const OrderIcon: React.FC<IconProps> = ({ size = 20, color = '#2F80ED' }) => wrap(
    <g fill="none" stroke={color} strokeWidth={2} strokeLinecap="round">
        <rect x="3" y="3" width="7" height="7" rx="1" fill={color} opacity="0.2" />
        <rect x="14" y="3" width="7" height="7" rx="1" fill={color} opacity="0.4" />
        <rect x="3" y="14" width="7" height="7" rx="1" fill={color} opacity="0.7" />
        <rect x="14" y="14" width="7" height="7" rx="1" fill={color} />
        <text x="6.5" y="9" fill={color} fontSize="6" fontWeight="700" textAnchor="middle">1</text>
        <text x="17.5" y="9" fill={color} fontSize="6" fontWeight="700" textAnchor="middle">2</text>
        <text x="6.5" y="20" fill={color} fontSize="6" fontWeight="700" textAnchor="middle">3</text>
        <text x="17.5" y="20" fill="#fff" fontSize="6" fontWeight="700" textAnchor="middle">4</text>
    </g>, size);

// 꽝 (폭탄)
export const BombIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <circle cx="11" cy="14" r="7" fill="#333" />
        <circle cx="8" cy="12" r="1.5" fill="#666" />
        <path d="M16 9 L18 7 L19 8 L21 6" stroke="#F2994A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <circle cx="21" cy="6" r="1.5" fill="#EB5757" />
        <circle cx="21" cy="6" r="0.8" fill="#F2C94C" />
    </g>, size);

// 통과 (체크)
export const CheckIcon: React.FC<IconProps> = ({ size = 20, color = '#27AE60' }) => wrap(
    <g>
        <circle cx="12" cy="12" r="10" fill={color} />
        <path d="M7 12 L10.5 15.5 L17 8" stroke="#fff" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </g>, size);

// 장소 (핀)
export const PinIcon: React.FC<IconProps> = ({ size = 20, color = '#EB5757' }) => wrap(
    <g>
        <path d="M12 2 C8 2 5 5 5 9 C5 14 12 22 12 22 S19 14 19 9 C19 5 16 2 12 2 Z" fill={color} />
        <circle cx="12" cy="9" r="2.5" fill="#fff" />
    </g>, size);

// 카페 (커피잔)
export const CafeIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <path d="M4 8 H16 V14 Q16 18 10 18 Q4 18 4 14 Z" fill="#8B5A3C" />
        <path d="M16 10 Q20 10 20 13 Q20 16 16 16" stroke="#8B5A3C" strokeWidth="1.5" fill="none" />
        <path d="M7 5 Q6 3 7 2 M10 5 Q9 3 10 2 M13 5 Q12 3 13 2" stroke="#ccc" strokeWidth="1" fill="none" opacity="0.7" />
    </g>, size);

// 맥주
export const BeerIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <rect x="5" y="8" width="10" height="12" rx="1" fill="#F2C94C" />
        <rect x="5" y="6" width="10" height="3" fill="#fff" />
        <circle cx="7" cy="6" r="1" fill="#fff" />
        <circle cx="10" cy="5" r="1.2" fill="#fff" />
        <circle cx="13" cy="6" r="1" fill="#fff" />
        <path d="M15 10 Q20 10 20 14 Q20 18 15 18" stroke="#F2C94C" strokeWidth="1.5" fill="none" />
    </g>, size);

// 노래방 (마이크)
export const MicIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <rect x="9" y="3" width="6" height="12" rx="3" fill="#BB6BD9" />
        <path d="M6 11 Q6 17 12 17 Q18 17 18 11" stroke="#BB6BD9" strokeWidth="1.8" fill="none" strokeLinecap="round" />
        <line x1="12" y1="17" x2="12" y2="21" stroke="#BB6BD9" strokeWidth="2" strokeLinecap="round" />
        <line x1="9" y1="21" x2="15" y2="21" stroke="#BB6BD9" strokeWidth="2" strokeLinecap="round" />
    </g>, size);

// 집
export const HomeIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <path d="M3 11 L12 3 L21 11 L21 20 L14 20 L14 14 L10 14 L10 20 L3 20 Z" fill="#F2994A" stroke="#C0392B" strokeWidth="1.2" />
    </g>, size);

// 디저트 (아이스크림)
export const DessertIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <path d="M8 10 L12 21 L16 10 Z" fill="#E6C297" />
        <circle cx="12" cy="9" r="4" fill="#EF7C9F" />
        <circle cx="9.5" cy="7" r="2.5" fill="#F8C8DC" />
        <circle cx="13.5" cy="7" r="2.5" fill="#EF7C9F" />
    </g>, size);

// PC방 (게임패드)
export const GameIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <path d="M6 8 Q3 8 3 13 Q3 18 6 18 Q8 18 9 16 L15 16 Q16 18 18 18 Q21 18 21 13 Q21 8 18 8 Z" fill="#2F80ED" />
        <rect x="5" y="12" width="3" height="1" fill="#fff" />
        <rect x="6" y="11" width="1" height="3" fill="#fff" />
        <circle cx="15" cy="12" r="1" fill="#fff" />
        <circle cx="17" cy="14" r="1" fill="#fff" />
    </g>, size);

// 볼링
export const BowlingIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <circle cx="8" cy="14" r="6" fill="#333" />
        <circle cx="6" cy="12" r="0.8" fill="#fff" />
        <circle cx="9" cy="11" r="0.8" fill="#fff" />
        <circle cx="7" cy="15" r="0.8" fill="#fff" />
        <path d="M17 3 Q19 6 19 12 Q19 16 17 20 Q15 16 15 12 Q15 6 17 3 Z" fill="#fff" stroke="#333" strokeWidth="1.2" />
        <ellipse cx="17" cy="8" rx="1.5" ry="0.5" fill="#EB5757" />
    </g>, size);

// 택시/해산
export const TaxiIcon: React.FC<IconProps> = ({ size = 20 }) => wrap(
    <g>
        <rect x="3" y="12" width="18" height="6" rx="1.5" fill="#F2C94C" />
        <rect x="6" y="8" width="12" height="5" rx="1" fill="#F2C94C" />
        <rect x="7" y="9" width="10" height="3" fill="#56CCF2" />
        <rect x="9" y="5" width="6" height="3" fill="#333" />
        <circle cx="7" cy="18" r="1.8" fill="#333" />
        <circle cx="17" cy="18" r="1.8" fill="#333" />
    </g>, size);

export type LadderIconKey = 'target' | 'person' | 'order' | 'bomb' | 'check'
    | 'pin' | 'cafe' | 'beer' | 'mic' | 'home' | 'dessert' | 'game' | 'bowling' | 'taxi' | 'edit' | 'ladder';

export const renderLadderIcon = (key: LadderIconKey, size = 20): React.ReactElement => {
    switch (key) {
        case 'target': return <TargetIcon size={size} />;
        case 'person': return <PersonIcon size={size} />;
        case 'order': return <OrderIcon size={size} />;
        case 'bomb': return <BombIcon size={size} />;
        case 'check': return <CheckIcon size={size} />;
        case 'pin': return <PinIcon size={size} />;
        case 'cafe': return <CafeIcon size={size} />;
        case 'beer': return <BeerIcon size={size} />;
        case 'mic': return <MicIcon size={size} />;
        case 'home': return <HomeIcon size={size} />;
        case 'dessert': return <DessertIcon size={size} />;
        case 'game': return <GameIcon size={size} />;
        case 'bowling': return <BowlingIcon size={size} />;
        case 'taxi': return <TaxiIcon size={size} />;
        case 'edit': return <EditIcon size={size} />;
        case 'ladder': default: return <LadderIcon size={size} />;
    }
};
